export default {
  "h1-title": "MT4便利ツール",
  imgUrlLang: "-en",
  "public-btn-text": "今すぐ登録",
  screen0: {
    title: "お取引の際に便利に使えるツールをご紹介いたします。",
  },
  screen1: {
    title: "オーバーレイチャートインジケーター",
    desc: "2つの通貨の指定期間内におけるプライスを重ねて表示することで、値動きの相対的な強さを表示することができます。",
  },
  screen2: {
    title: "MACDインジケーター（二重線）",
    desc: "株や先物取引でよく使われる指標です。MT4に含まれるMACDよりも、二重線のほうがより使いやすくなっています。",
  },
  screen3: {
    title: "MTDriver 損益統計インジケーター",
    desc: "各期間における損益を正確に把握するのに役立ちます。",
  },
  screen4: {
    title: "価格変更モバイルプッシュ通知",
    desc: "24時間ずっとマーケットを見る必要はありません。価格変動がスマートフォンに通知され、いち早く市場の動向を把握できます。",
  },
  screen5: {
    title: "ワンクリックでEAを閉じる",
    desc: "操作インターフェースはチャートインターフェースにあり、極端な市場状況が発生した場合に投資家がより迅速かつ便利に損失をストップするのに便利です。",
  },
  screen6: {
    title: "ワンクリック決済EA",
    desc: "操作ボタンはチャート画面上にあり、極端な相場状況が発生した際に、投資家がより迅速かつ簡単に決済を行い、損失を防ぐのに役立ちます。",
  },
  screen7: {
    title: "時間指定注文EA",
    desc: `指定した時間に注文を行う EA です。\\MQL4\\Experts フォルダに入れると簡単にお使いいただけます。`,
  },
  EA交易与指标: "EAとメタトレーダーインジケーター",
  EBC独家精选的MT4:
    "EBC独自のMT4/MT5インジケーターとEAトレーディングツールは、意思決定の精度と運用効率を高め、戦略を最適化し、市場機会を捉え、競争力高めることを可能にします。",
  EBCTurbo账户分析系统:
    "EBC Turbo：MetaTraderインジケーターで取引を分析、戦略を最適化します。",
  实用型技术指标集: "使いやすいインジケーター：市場トレンドを把握し、取引チャンスをつかみます。",
  外汇EA策略执行器: "FX EA取引ツール：市場の変化に効率的に対応し、常に一歩先の判断を可能にします。",
  EBCTurbo账户分析系统2: "EBC Turbo口座分析システム",
  EBC独家盈亏统计和历史回溯工具:
    "EBC独自の損益統計と取引履歴ツールを用いることで、様々な角度から取引を分析することができ、より洗練された取引戦略の立案にお役立ていただけます。",
  净值收益曲线: "資本収益曲線",
  收益率: "収益率",
  最大回撤: "最大ドローダウン",
  标准差: "標準偏差",
  获利系数: "プロフィットファクター",
  夏普比率: "シャープレシオ",
  盈利交易: "勝率",
  六维评级图: "6次元評価チャート",
  每日: "日次/月次統計",
  获取EBCTurbo: "EBC Turboを利用する",
  实用型技术指标集2: "実用的なテクニカルインジケーター",
  经过优化的常用技术指标:
    "最適化されたテクニカルインジケーターはカスタム設定可能で、トレンドの把握に役立てられます。",
  同图商品叠加工具: "オーバーレイチャート",
  帮助投资者通过叠加两个商品的走势:
    "2つの銘柄間のレジスタンスラインの強さを分析し、重要なブレイクアウトポイントを特定し、意思決定の精度を高めるのに役立ちます。",
  MACD专业指标: "MACDプロインジケーター（デュアルライン）",
  提供比普通MACD更为精准的双线指标:
    "標準バージョンよりも精度の高いデュアルラインMACDインジケーターを提供し、投資家が市場の売買シグナルをより的確に見極め、優れた収益チャンスを獲得できるよう支援します。",
  MTDriver盈亏统计指标: "MTDriver損益統計",
  该指标可协助投资者实时统计不同周期内的盈亏情况:
    "様々な期間の損益をリアルタイムで追跡。より正確な取引戦略の立案のためのデータサポートを提供します。",
  价格变动手机推送通知: "価格変動通知",
  实时监控市场价格波动:
    "市場価格の変動をリアルタイムで監視。重要な変化が発生した場合には、携帯電話に即時にプッシュ通知を送信します。マーケットの急変動に迅速に対応いただけます。",
  获取指标: "インジケーターを入手",
  外汇EA策略执行器2: "FX EA戦略実行ツール",
  基于高级算法自动执行EA交易策略:
    "高度なアルゴリズムを用いてEA（自動売買）戦略を実行し、市場の変化にリアルタイムで適応。迅速かつ安全で効率的な取引を実現します。",
  定时下单EA软件: "時間指定EAソフトウェア",
  通过MT4EA:
    "MT4またはMT5を通じて、あらかじめ設定された時間に自動で注文を実行します。特定の時間帯に基づく取引戦略に最適です。",
  EA交易常见问题: "EA取引に関するよくある質問",
  qaList: [
    {
      q: "1. EA 取引とは何ですか? どのような機能がありますか?",
      a: ["EA（エキスパートアドバイザー）取引とは、MT4またはMT5プラットフォーム上で自動的に取引を行うシステムのことです。あらかじめ設定された戦略に基づいて、買い・売り・損切り・利確などの注文を自動で実行します。これにより、取引の効率を高め、パソコンの前に張り付いて取引する必要がなく、感情に左右されず一貫した取引判断が可能になります。"],
    },
    {
      q: "2. MT4とMT5用のEAソフトウェアに違いがありますか？",
      a: ["MT4とMT5用のEAは異なるプログラミング言語を使用しています。MT4はMQL4を、MT5はMQL5を採用しており、両者に互換性はありません。MQL4は直感的な構造によりEA構築が容易である一方、MQL5はより高度な機能で、マルチスレッド処理によるバックテストにも対応しています。取引戦略に応じて最適なEAを選びましょう。"],
    },
    {
      q: "3. 同一のMT4/MT5で複数のEAを同時に稼働できますか？",
      a: ["はい、同一のMT4/MT5プラットフォーム上で複数のEAを稼働できます。ただし、干渉やリソースの過負荷になりますので、チャート毎に１つのEAのみ稼働させるようご注意ください。"],
    },
    {
      q: "4.1つのEAで複数の通貨ペアを取引できますか？",
      a: ["はい、EAの設計次第で可能です。単一の特定通貨ペア用のEAもあれば、複数ペアに対応するEAもあります。特にMT5対応のEAは、マルチスレッド処理により効率よく取引することができます。"],
    },
    {
      q: "5. 自分に合ったEAを選ぶには？",
      a: ["自分の取引スタイル（トレンドフォローやスキャルピング等）、資金保有額、リスク許容度などを考慮してください。EAのバックテスト結果や実際の取引実績、MT4/MT5の適応性もご確認ください。デモ口座で安定性と利益性を試運転してから本番利用することをおすすめします。"],
    },
    {
      q: "6. EA取引で利益は保証されますか？",
      a: ["どんな取引ツールも利益を保証することはできません。EAのパフォーマンスは、取引戦略、市場環境、リスク管理に大きく左右されます。MT4やMT5のEAはあくまで取引を支援するツールであり、トレーダー自身が運用状況を監視し、必要に応じて調整を行う必要があります。"],
    },
  ],
  url:"https://ebcturbo.com/tools?language=ja"
};
